var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_13259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6632 3.68457H49.1711L43.0667 18.8554H39.013L32.9087 3.68457H36.4166L41.0319 15.1991L45.6632 3.68457Z",
    fill: "#FF564F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62835 0.548096H1.43311V18.8611H4.62835V0.548096Z",
    fill: "#FF564F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3661 18.8604L6.36621 9.70389L13.3661 0.547363H17.3774L10.4676 9.70389L17.3774 18.8604H13.3661Z",
    fill: "#FF564F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0238 3.28174C21.5265 3.28174 18.8929 5.21584 18.7022 8.09315L18.681 8.43228H21.8179L21.8709 8.18323C22.1624 6.83201 23.2645 6.09016 24.9708 6.09016C26.8254 6.09016 27.8905 7.02277 27.8905 8.65484V9.59275L23.9534 9.8153C20.4137 10.022 18.2729 11.7547 18.2729 14.4466C18.2729 17.2868 20.4031 19.1891 23.5348 19.1891C25.4 19.1891 26.7618 18.6804 27.8746 17.5411V18.9294H31.0539V8.41109C31.0539 5.29533 28.6482 3.28174 25.0238 3.28174ZM27.8852 12.0514V12.9946C27.6785 15.0559 26.2531 16.3489 24.07 16.4548C23.2274 16.4972 22.5015 16.2694 22.0246 15.8137C21.6484 15.4586 21.4523 14.9817 21.4523 14.4413C21.4523 13.2331 22.4803 12.4754 24.2872 12.3588L27.8852 12.0514Z",
    fill: "#FF564F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2943 3.28174C53.7971 3.28174 51.1635 5.21584 50.9727 8.09315L50.9515 8.43228H54.0885L54.1415 8.18323C54.4329 6.83201 55.5351 6.09016 57.2414 6.09016C59.096 6.09016 60.1611 7.02277 60.1611 8.65484V9.59275L56.2293 9.8153C52.6896 10.022 50.5488 11.7547 50.5488 14.4466C50.5488 17.2868 52.679 19.1891 55.8106 19.1891C57.6759 19.1891 59.0377 18.6804 60.1505 17.5411V18.9294H63.3298V8.41109C63.3245 5.29533 60.9188 3.28174 57.2943 3.28174ZM60.1611 12.0514V12.9946C59.9544 15.0559 58.529 16.3489 56.3458 16.4548C55.5033 16.4972 54.7774 16.2694 54.3005 15.8137C53.9242 15.4586 53.7282 14.9817 53.7282 14.4413C53.7282 13.2331 54.7562 12.4754 56.5631 12.3588L60.1611 12.0514Z",
    fill: "#FF564F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_13259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.8451,
    height: 19.0761,
    fill: "white",
    transform: "translate(0.956055 0.330566)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKava);
export default __webpack_public_path__ + "static/media/kava.21985427da0e66fe97a20573e3f5d649.svg";
export { ForwardRef as ReactComponent };